import * as actionTypes from "../actionTypes";

export const getSubAdmin = payload => ({
    type: actionTypes.GET_SUB_ADMIN,
    payload
})

export const setSubAdmin = payload => ({
    type: actionTypes.SET_SUB_ADMIN,
    payload
})

export const createSubAdmin = payload => ({
    type: actionTypes.CREATE_SUB_ADMIN,
    payload
})

export const updateSubAdmin = payload => ({
    type: actionTypes.UPDATE_SUB_ADMIN,
    payload
})

export const deleteSubAdmin = payload => ({
    type: actionTypes.DELETE_SUB_ADMIN,
    payload
})

export const changeSubAdminStatus = payload => ({
    type: actionTypes.CHANGE_SUB_ADMIN_STATUS,
    payload
})